import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateMenuItem(payload) {
    return requestPost(apiPath.MENU_ITEM.path, payload)
  },

  GetOneMenuItem(menuItemID) {
    return requestGet(`${apiPath.MENU_ITEM.path}/${menuItemID}`)
  },

  GetAllMenuItem(paging, sorting, filtering) {
    return requestGet(apiPath.MENU_ITEM.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_menuItemCode: filtering.menuItemCode,
      f_menuGroupCode: filtering.menuGroupCode,
      f_outletName: filtering.outletName,
      f_menuGroupName: filtering.menu_group_name,
      f_sequence: filtering.sequence,
      f_isTaxable: filtering.isTaxable,
      f_isActive: filtering.isActive,
      f_isMenuset: filtering.isMenuset,
      f_isCD: filtering.isCD,
      f_outOfStock: filtering.outOfStock,
      f_name: filtering.name
    })
  },

  UpdateMenuItem(menuItemID, payload) {
    return requestPut(`${apiPath.MENU_ITEM.path}/${menuItemID}`, payload)
  },

  DeleteMenuItem(menuItemID) {
    return requestDelete(`${apiPath.MENU_ITEM.path}/${menuItemID}`)
  },

  changeStockStatus(menuItemID, payload) {
    return requestPut(`${apiPath.MENU_ITEM_STOCK.path}/${menuItemID}`, payload)
  }
}

export default api
